import React from 'react';
import ShipTogetherAddress from '../../ship-together-address';

export default {
  id: 'ship-together-address',
  render: (alert) => <ShipTogetherAddress address={alert.address} />,
};
